import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {environment} from "../../environments/environment";

// import {EventEmitter} from "protractor";

@Component({
  selector: 'app-map-header',
  templateUrl: './map-header.component.html',
  styleUrls: ['./map-header.component.css']
})
export class MapHeaderComponent implements OnInit {
  searchInput: string = '';
  @Output()
  searchOut: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  layersChecked: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  additionnalLayer: EventEmitter<any> = new EventEmitter<any>();

  domainePublicNaturel: boolean = false;
  pag: boolean = false;
  zdup: boolean = false;
  zoneSecuritaire: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  inputChanged(event: string): void {
    this.searchInput = event;
    console.log("key", this.searchInput)
    /*  if(event.length ==9){
        this.searchOut.emit({
          code: event
        })
      }*/

  }

  oneClickSearch(): void {
    this.searchOut.emit({
      code: this.searchInput
    })
  }

  layersCheckedOn(value: any): void {
    this.layersChecked.emit({
      value: value
    })

  }

  updateChange(val: string) {
    if(val=='dpn'){
      this.domainePublicNaturel=!this.domainePublicNaturel
      console.log('dpn', val, this.domainePublicNaturel)
    }
    if(val=='zoneSecuritaire'){
      this.zoneSecuritaire=!this.zoneSecuritaire
      console.log('zoneSecuritaire', val, this.zoneSecuritaire)
    }
    if(val=='pag'){
      this.pag=!this.pag
      console.log('pag', val, this.pag)
    }
    if(val=='zdup'){
      this.zdup=!this.zdup
      console.log('zdup', val, this.zdup)
    }

    this.additionnalLayer.emit({
      dpn: this.domainePublicNaturel,
      zsf: this.zoneSecuritaire,
      pag:this.pag,
      zdup: this.zdup
    })


  }

  protected readonly environment = environment;
}
